import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import { css } from "react-emotion";

const modalStyles = css`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  overflow: visible;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  width: 35rem;

  .buttons {
    display: flex;
    justify-content: space-between;
    margin: 15px 0 0;
  }
`;

const overlayStyles = css`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 1021; /* above navs, below sweetalert */
`;

class DefaultModal extends React.Component {
  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        className={modalStyles}
        overlayClassName={overlayStyles}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}>
        {this.props.children}
      </Modal>
    );
  }
}

DefaultModal.defaultProps = {
  isOpen: false,
};

DefaultModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default DefaultModal;
